var map = {
	"./1_1_1.jpg": "985c",
	"./1_1_2.jpg": "2139",
	"./1_2_1.jpg": "4db9",
	"./1_2_2.jpg": "7e80",
	"./2_1_1.jpg": "fb6e",
	"./2_1_2.jpg": "577a",
	"./2_2_1.jpg": "8dfd",
	"./2_2_2.jpg": "0d12",
	"./2_3_1.jpg": "a12b",
	"./3_1_1.jpg": "2370",
	"./3_1_2.jpg": "3fc6",
	"./4_1_1.jpg": "d250"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "22c6";